import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select
} from "@mui/material";
import {useState, useEffect} from "react";
import {saveScheduler} from "../services/SchedulerService";
import Loader from "./Loader";
import SaveIcon from '@mui/icons-material/Save';

const SchedulerNewDialog = ({open, handleClose, company, oldData}) => {

  const [loading, setLoading] = useState(false);

  const [data, setData] = useState({
    dayOfWeek: oldData?.dayOfWeek != null ? oldData.dayOfWeek : "SUNDAY",
    hour: oldData?.hour  != null ? oldData.hour : 6,
    featureType: oldData?.featureType  != null ? oldData.featureType : "NEWS",
    companyId: company.id,
    id: oldData?.id  != null ? oldData.id : null
  });

  useEffect(() => {
    setData({
      dayOfWeek: oldData?.dayOfWeek != null ? oldData.dayOfWeek : "SUNDAY",
      hour: oldData?.hour  != null ? oldData.hour : 6,
      featureType: oldData?.featureType  != null ? oldData.featureType : "NEWS",
      companyId: company.id,
      id: oldData?.id  != null ? oldData.id : null
    });
  },[oldData]);

  const isEditing = oldData?.id != null;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        component: 'form',
        onSubmit: (event) => {
          event.preventDefault();
          setLoading(true);
          saveScheduler(data)
            .then(r => handleClose())
            .finally(() => setLoading(false));
        },
      }}
    >
      <DialogTitle>{isEditing ? 'Edit Schedule' : 'Create Schedule'}</DialogTitle>
      <DialogContent>
        <Loader loading={loading}/>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, pt: 1 }}>
          <FormControl size="small" fullWidth>
            <InputLabel>Day of Week</InputLabel>
            <Select
              label="Day of Week"
              value={data.dayOfWeek}
              onChange={e => setData(prv => ({ ...prv, dayOfWeek: e.target.value }))}
            >
              <MenuItem value="SUNDAY">Sunday</MenuItem>
              <MenuItem value="MONDAY">Monday</MenuItem>
              <MenuItem value="TUESDAY">Tuesday</MenuItem>
              <MenuItem value="WEDNESDAY">Wednesday</MenuItem>
              <MenuItem value="THURSDAY">Thursday</MenuItem>
              <MenuItem value="FRIDAY">Friday</MenuItem>
              <MenuItem value="SATURDAY">Saturday</MenuItem>
            </Select>
          </FormControl>

          <FormControl size="small" fullWidth>
            <InputLabel>Hour</InputLabel>
            <Select
              label="Hour"
              value={data.hour}
              onChange={e => setData(prv => ({ ...prv, hour: e.target.value }))}
            >
              {Array.from(Array(24).keys()).map((i) => (
                <MenuItem key={i} value={i}>
                  {i < 10 ? `0${i}:00` : `${i}:00`} (GMT+3: {(i + 3) % 24 < 10 ? `0${(i + 3) % 24}:00` : `${(i + 3) % 24}:00`})
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl size="small" fullWidth>
            <InputLabel>Feature Type</InputLabel>
            <Select
              label="Feature Type"
              value={data.featureType}
              onChange={e => setData(prv => ({ ...prv, featureType: e.target.value }))}
            >
              <MenuItem value="NEWS">News</MenuItem>
              <MenuItem value="WEEKLY_DIGEST">Weekly Digest</MenuItem>
              <MenuItem value="NEWS_GENERAL">News General</MenuItem>
              <MenuItem value="NEWS_FINANCE">News Finance</MenuItem>
              <MenuItem value="SINGLE_POST">Single Post</MenuItem>
              <MenuItem value="ARTICLE">Article</MenuItem>
              <MenuItem value="BRANDING_BANNER">Branding Banner</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose}>Cancel</Button>
        <Button variant="contained" type="submit" startIcon={<SaveIcon />}>
          {isEditing ? 'Update' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SchedulerNewDialog;
